import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';
import { BsFillEyeFill } from 'react-icons/bs';
import { FaListAlt } from 'react-icons/fa';
import './UserProcesses.css';
import UserDetails, { processRegistration } from './UserDetails';

export function UserProcessesColumn({ processes = [] }) {
  return processes.length ? <div className="user-processes-cell">
    {processes.map(process => <span key={process.id} title={process.name}>{process.name}</span>)}
  </div> : <span className="text-muted">Nenhum vínculo</span>;
}

export default function UserProcesses({ selected, onHide, fiscal = false, avaliador = false, changeText = false }) {
  if (!selected) return null;
  const label = changeText ? 'Vagas/Cargos' : 'Processos seletivos';
  const person = avaliador ? 'avaliador' : (fiscal ? 'fiscal' : 'candidato');
  const route = avaliador ? 'avaliadores' : (fiscal ? 'fiscais' : 'candidatos');
  const processes = selected.processos || [];
  const initials = selected.name?.trim().split(/\s+/).filter(Boolean).map(word => word[0]).filter((_, index, names) => index === 0 || index === names.length - 1).join('').toUpperCase();
  return <Modal show centered onHide={onHide} className="user-processes-modal" dialogClassName="user-processes-dialog" aria-labelledby="user-processes-title">
    <Modal.Header closeButton closeLabel="Fechar">
      <div className="user-processes-heading">
        <span className="user-processes-icon"><FaListAlt aria-hidden="true" /></span>
        <div><Modal.Title id="user-processes-title">{label} do {person}</Modal.Title><p>Escolha um vínculo para visualizar os detalhes do {person}.</p></div>
      </div>
    </Modal.Header>
    <Modal.Body>
      <div className="user-processes-person"><span className="user-processes-avatar" aria-hidden="true">{initials}</span><div><strong>{selected.name}</strong>{selected.email && <span>{selected.email}</span>}</div><span className="user-processes-count">{processes.length} {processes.length === 1 ? 'vínculo' : 'vínculos'}</span></div>
      <UserDetails user={selected} candidate={!fiscal && !avaliador} fiscal={fiscal} identity={false} showRegistration={false} />
      {processes.length ? <div className="user-processes-list">
        {processes.map(process => <div key={process.id} className="user-processes-item">
          <div><strong>{process.name}</strong>{!fiscal && !avaliador && <span className="user-processes-registration">Número de inscrição: {processRegistration(selected, process.id) ?? 'Não informado'}</span>}</div>
          <Link target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary" aria-label={`Ver ${person} em ${process.name}`} to={`/${route}_vinculados/show/${selected.id}/${process.id}`} onClick={onHide}><BsFillEyeFill aria-hidden="true" /> Ver {person}</Link>
        </div>)}
      </div> : <div className="user-processes-empty"><FaListAlt aria-hidden="true" /><p>Nenhum vínculo encontrado.</p></div>}
    </Modal.Body>
    <Modal.Footer><button type="button" className="btn btn-outline-secondary" onClick={onHide}>Fechar</button></Modal.Footer>
  </Modal>;
}
